import _ from "lodash";

import { CONSTRUCTION_TYPES, PROPERTY_TYPES } from "./constants";

export const getConstructionTypeLabelByValue = ({ value }: { value: string }) =>
  _.find(CONSTRUCTION_TYPES, ["value", value])?.label || value;

export const getConstructionTypeValueByLabel = ({ label }: { label: string }) =>
  _.find(CONSTRUCTION_TYPES, ["label", label])?.value || label;

export const getPropertyTypeLabelByValue = ({ value }: { value: string }) =>
  _.find(PROPERTY_TYPES, ["value", value])?.label || value;

export const getPropertyTypeValueByLabel = ({ label }: { label: string }) =>
  _.find(PROPERTY_TYPES, ["label", label])?.value || label;

export const transformEmptyStringsToNullRecursive = ({
  data,
}: {
  data: Record<string, any>;
}): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key,
      typeof value === "string" && value === ""
        ? null
        : typeof value === "object" && value !== null
          ? transformEmptyStringsToNullRecursive({ data: value })
          : value,
    ])
  );
};
